<template>
  <div v-if="isSetRow == '0'" >
    <b-button :disabled="item == null || item['status'] == null || item['status'].indexOf('1') != -1 || item['status'].indexOf('2') != -1" size="sm" @click="showModal" :variant="variant">ラベルのみ印刷</b-button>
  </div>
  <div v-else>
    <b-button size="sm" @click="showModalSet" :variant="variant" :disabled="item == null || !item['printStatus']">　ラベル印刷　</b-button>
  </div>
</template>

<script>
import * as api from '@/api';

export default {
  props: {
    memberId: { default: '' },
    item: { default: [] },
    isSetRow: { default: '0' },
    variant: { default: '' },
  },
  data() {
    return {
      additionalOver: false,
      updateStatus: '',
    };
  },
  computed: {
  },
  methods: {
    showModal() {
      this.printBarcode();
    },
    showModalSet() {
      this.printBarcodeSet();
    },
    printBarcode() {
      const WinPrint = window.open('', '', 'width=500,height=555,scrollbars=0,menuBar=0,toolbar=0,location=0,status=0');
      var con = this.item['productCondition'] === '0' ? 'NEW' : 'USED';
      var pname = this.item['productNameEn'].substring(0, 25);
      var printUrl = '';
      // var fnsku = this.item['fnsku'].replace('E', 'e');
      var fnsku = this.item['fnsku'];
      // ラベルに表示する会員番号を成形
      var memberNumber = this.memberId.substr(7);
      var memberNumberOne = this.memberId.substr(7,1);
      if(memberNumberOne.search(/[A-Z]/) >= 0){
        memberNumber = memberNumberOne.toLowerCase() + '_' + this.memberId.substr(8);
      }
      // console.log("aaa");
      if(this.item['matomeStatus']){
        printUrl = '<div style="text-align:center"><img src="' + this.item['barcodeUrl'] + '" width="195" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + fnsku + '</div><div style="height:5px;font-size:9px;text-align:center;margin-top:-5px;padding:0">[' + con + '] ' + pname +'<br>' + memberNumber + ' <label style="background-color:black;color:white;border-radius:1rem;padding-left:0.5rem;padding-right:0.5rem">M</label></div>';
      } else{
        printUrl = '<div style="text-align:center"><img src="' + this.item['barcodeUrl'] + '" width="195" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + fnsku + '</div><div style="height:5px;font-size:9px;text-align:center;margin-top:-5px;padding:0">[' + con + '] ' + pname +'<br>' + memberNumber + '</div>';
      }
      WinPrint.document.body.innerHTML = printUrl;
      const sleep = (waitSeconds) => {
        return new Promise(resolve => {
          setTimeout(() => {
            WinPrint.window.print();
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.close();
          }, waitSeconds)
        })
      }
      sleep(500);
    },
    printBarcodeSet() {
      const WinPrint = window.open('', '', 'width=500,height=555,scrollbars=0,menuBar=0,toolbar=0,location=0,status=0');
      var con = this.item['productCondition'] === '0' ? 'NEW' : 'USED';
      var pname = this.item['setParentProductName'].substring(0, 25);
      var printUrl = '';
      var fnsku = this.item['fnsku'].replace('E', 'e');

            // ラベルに表示する会員番号を成形
      var memberNumber = this.memberId.substr(7);
      var memberNumberOne = this.memberId.substr(7,1);
      if(memberNumberOne.search(/[A-Z]/) >= 0){
        memberNumber = memberNumberOne + '_' + this.memberId.substr(8);
      }

      if(this.item['matomeStatus']){
        printUrl = '<div style="text-align:center"><img src="' + this.item['barcodeUrl'] + '" width="195" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + fnsku + '</div><div style="height:5px;font-size:9px;text-align:center;margin-top:-5px;padding:0">[' + con + '] ' + pname +'<br>(' + memberNumber + ') <label style="background-color:black;color:white;border-radius:1rem;padding-left:0.5rem;padding-right:0.5rem">M</label></div>';
      } else{
        printUrl = '<div style="text-align:center"><img src="' + this.item['barcodeUrl'] + '" width="195" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + fnsku + '</div><div style="height:5px;font-size:9px;text-align:center;margin-top:-5px;padding:0">[' + con + '] ' + pname +'<br>(' + memberNumber + ')</div>';
      }
      WinPrint.document.body.innerHTML = printUrl;

      const sleep = (waitSeconds) => {
        return new Promise(resolve => {
          setTimeout(() => {
            WinPrint.window.print();
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.close();
          }, waitSeconds)
        })
      }
      sleep(500);
    },
  },
};
</script>

<style>
@media print{
  .noprint{display:none;}
}
.barcode-text{
  text-align: center;
  font-size: 5px;
}
</style>
